<template>
  <div class="bg-white h-100">
    <div class="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
      <i class="mdi" :class="icon" style="font-size: 1.5rem"></i>
      <h4 class="text-center m-0">{{ title }}</h4>
      <span class="clickable" @click="$emit('close')">
        <i class="mdi mdi-close" style="font-size: 1.5rem"></i>
      </span>
    </div>
    <b-list-group flush v-if="documentShareWith.length">
      <b-list-group-item
        v-for="viewer in documentShareWith"
        :key="viewer.id"
      >
        <i
          style="font-size: 20px"
          class="mr-2 mdi"
          :class="`mdi-${viewer.icon}`"
        />
        <span class="flex-grow-1">
          {{ viewer.name }}
        </span>
      </b-list-group-item>
    </b-list-group>
    <LmSvgIcon
      v-else
      wrapperClass="d-flex mt-5 justify-content-center align-items-center flex-column"
      width="6em"
      icon="LmNoDataIcon"
      text="Este documento no se encuentra compartido."
    />
  </div>
</template>

<script>
export default {
  props: {
    shareWith: {
      type: Array,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    documentShareWith () {
      return this.shareWith.map(el => {
        return {
          ...el,
          icon: 'account'
        }
      }) || []
    }
  }
}
</script>
